/** Gets the value of a cookie with the given name. */
export function getCookie<T = string | undefined>(name: string): T {
  return document.cookie.split(/\s*;\s*/g)
    .map(pair => pair.split(/=/))
    .filter(([key]) => key === name)
    .map(([_, value]) => value)[0] as T;
}